import { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export default function AboutDialog({ open, onOpenChange }) {
  useEffect(() => {
    // Load Buy Me a Coffee script when dialog opens
    if (open && !document.querySelector('script[src*="buymeacoffee"]')) {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js';
      script.async = true;
      script.setAttribute('data-name', 'bmc-button');
      script.setAttribute('data-slug', 'joshuaguthrie');
      script.setAttribute('data-color', '#416ec8');
      script.setAttribute('data-emoji', '');
      script.setAttribute('data-font', 'Lato');
      script.setAttribute('data-text', 'Buy me a coffee');
      script.setAttribute('data-outline-color', '#ffffff');
      script.setAttribute('data-font-color', '#ffffff');
      script.setAttribute('data-coffee-color', '#FFDD00');
      
      document.body.appendChild(script);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>About UpNext To-Do</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 text-sm text-muted-foreground py-3">
          <p>
            UpNext is an intuitive task management application designed to help you organize and prioritize your tasks effectively. If you find it helpful, please consider supporting my work through Buy Me a Coffee!
          </p>
          
          <div className="flex justify-center py-2">
            <a 
              href="https://www.buymeacoffee.com/joshuaguthrie" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <img 
                src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" 
                alt="Buy Me A Coffee" 
                style={{ height: '40px', width: '145px' }}
              />
            </a>
          </div>

          <p>
            This app's code was developed using Emergent, a full-stack AI coding tool. For support or feedback, please contact me at{' '}
            <a 
              href="mailto:guthrie144@proton.me" 
              className="text-foreground underline hover:no-underline"
            >
              guthrie144@proton.me
            </a>
            . I would love to hear from you!
          </p>
          
          <div className="flex justify-end mt-4">
            <div className="text-right text-foreground">
              <p className="italic font-bold">— Joshua Guthrie</p>
              <p>FigByte Dev</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
